<template>
  <LayCollapseTransition v-if="type === 'collapse'">
    <slot></slot>
  </LayCollapseTransition>
</template>

<script>
import LayCollapseTransition from './collapseTransition.vue'

export default {
  name: 'LayTransition',
  props: {
    type: {
      type: String,
      default: 'collapse',
    },
    enable: {
      type: Boolean,
      default: true,
    },
    time: {
      type: [String, Number],
      default: 0.3,
    },
  },
  provide() {
    return {
      time: this.time,
    }
  },
  components: {
    LayCollapseTransition,
  },
}
</script>
